import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function PasswordResetConfirm() {
  const [params] = useSearchParams();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();
  const token = params.get("token") || "";

  async function submit(e) {
    e.preventDefault();
    if (pw1 !== pw2) { toast.error("Passwörter stimmen nicht überein"); return; }
    if (pw1.length < 12) { toast.error("Passwort muss mindestens 12 Zeichen lang sein"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset-confirm", { token, new_password: pw1 });
      setDone(true);
      toast.success("Passwort geändert. Bitte neu anmelden.");
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Link ungültig oder abgelaufen");
    } finally { setSubmitting(false); }
  }

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" data-testid="pw-reset-invalid">
        <div className="max-w-md text-center space-y-3">
          <div className="text-2xl font-black">Ungültiger Link</div>
          <div className="text-zinc-400">Der Reset-Link ist unvollständig oder abgelaufen.</div>
          <Link to="/password-reset-request" className="inline-block text-cyan-400 hover:underline">Neuen Link anfordern</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="pw-reset-confirm-form">
        <div className="text-2xl font-black uppercase">Neues Passwort</div>
        <div className="text-sm text-zinc-500">Mindestens 12 Zeichen.</div>
        <div><Label>Neues Passwort</Label>
          <Input required type="password" minLength={12} data-testid="pw-reset-pw1" value={pw1} onChange={(e) => setPw1(e.target.value)} /></div>
        <div><Label>Wiederholen</Label>
          <Input required type="password" minLength={12} data-testid="pw-reset-pw2" value={pw2} onChange={(e) => setPw2(e.target.value)} /></div>
        <Button type="submit" disabled={submitting || done} data-testid="pw-reset-confirm-submit" className="w-full h-12 rounded-sm">
          {submitting ? "Speichern..." : "Passwort setzen"}
        </Button>
      </form>
    </div>
  );
}
